import type { CmsApiThreeSectionSliderBlockData } from '#/modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsThreeSectionSliderBlockMapping: CmsBlockMapping<CmsApiThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsThreeSectionSliderBlock').then((m) => ({
          default: m.CmsThreeSectionSliderBlock,
        })),
      { strategy: 'always' },
    ),
  };
